module.exports = __webpack_public_path__ + "img/localGroup.aa0d2799.png";